export enum FlowInstanceStatus {
  Initial = 'initial',
  Completed = 'completed',
}
